import { TableAdapter } from '@makyoapp/makyo-common'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { GroupedTable } from '@/core/db'
import { appIconKeys } from '@/shared/icons/constants'

interface RenderTableIconProps {
  table?: TableAdapter
  isPlaceholder?: boolean
}

export const TableIconMap: Record<GroupedTable['type'], React.ReactNode> = {
  user: <MaterialIcon size={16} icon={appIconKeys.tableUser} className='text-blue-500 shrink-0' />,
  session: <MaterialIcon size={16} icon={appIconKeys.tableSession} className='text-primary-500 shrink-0' />,
  snapshot: <MaterialIcon size={16} icon={appIconKeys.tableSnapshot} className='text-yellow-500 shrink-0' />,
  query: <MaterialIcon size={16} icon={appIconKeys.tableQuery} className='text-purple-500 shrink-0' />,
  source: <MaterialIcon size={16} icon={appIconKeys.table} className='shrink-0' />,
}

/**
 * RenderTableIcon
 *
 * @param table - The table to get the icon for
 * @returns The icon for the table
 */
export function RenderTableIcon({ table, isPlaceholder }: RenderTableIconProps) {
  if (isPlaceholder) {
    return <MaterialIcon size={16} icon={appIconKeys.table} className='shrink-0 text-light' />
  }

  return table?.isUserTable ? (
    <MaterialIcon size={16} icon={appIconKeys.tableUser} className='text-blue-500 shrink-0' />
  ) : table?.isSessionTable ? (
    <MaterialIcon size={16} icon={appIconKeys.tableSession} className='text-primary-500 shrink-0' />
  ) : table?.isSnapshot ? (
    <MaterialIcon size={16} icon={appIconKeys.tableSnapshot} className='text-yellow-500 shrink-0' />
  ) : table?.isQuery ? (
    <MaterialIcon size={16} icon={appIconKeys.tableQuery} className='text-purple-500 shrink-0' />
  ) : (
    <MaterialIcon size={16} icon={appIconKeys.table} className='shrink-0' />
  )
}
